import ManagementAddresses from './ManagementAddresses';

export default ManagementAddresses;
